// frontend/src/pages/StartupRedirect.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStoreHash } from '../api/config';

const StartupRedirect = () => {
  const navigate = useNavigate();
  const storeHash = getStoreHash();

  useEffect(() => {
    const checkCheckoutStatus = async () => {
      try {
        const res = await fetch(`/api/checkout/status?store_hash=${storeHash}`);
        const data = await res.json();

        if (!res.ok) throw new Error();

        // Native mode is ready the moment its webhook is registered (new installs
        // get this automatically at OAuth time); custom mode is ready once the
        // checkout script is installed. Anything else means the merchant hasn't
        // made a choice yet (or never finished setup) -> show the setup screen.
        const nativeReady = data.checkout_mode === 'native' && data.native_webhook_registered;
        const customReady = data.checkout_mode === 'custom' && data.installed;

        if (nativeReady || customReady) {
          navigate("/fees");
        } else {
          navigate("/setup-checkout");
        }
      } catch (err) {
        console.error("Redirect failed:", err);
        navigate("/setup-checkout");
      }
    };

    if (storeHash) checkCheckoutStatus();
    else navigate("/fees");
  }, [storeHash, navigate]);

  return null;
};

export default StartupRedirect;
